class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 100);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));
      facetForm.addEventListener('submit', (e) => e.preventDefault());
    } else {
      console.error('Facet form not found');
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    getCollectionItemsCount();

    // if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, { replace: false });
  }

  static renderSectionFromFetch(url, event) {
    // fetch(url)
    // Abort any in-flight request so we don’t queue
    // if (FacetFiltersForm.activeFetchController) {
    //   FacetFiltersForm.activeFetchController.abort();
    // }
    // FacetFiltersForm.activeFetchController = new AbortController();
    // const { signal } = FacetFiltersForm.activeFetchController;

    // fetch(url, { signal })
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        // });
      });
    // .catch((err) => {
    //   if (err && err.name === 'AbortError') return;
    //   console.error(err);
    // })
    // .finally(() => {
    //   FacetFiltersForm.activeFetchController = null;
    // });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (window.collection_handle) {
      ajaxinateCallBack();
      getCollectionItemsCount();
    } else if (window.search_url) {
      const event = new Event('section:load');
      document.dispatchEvent(event);
    }
    updateFormWithUrlParams();
    getActiveFacets();
  }

  // static renderFilters(html, event) {
  //   const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  //   const facetDetailsElements = parsedHTML.querySelectorAll(
  //     '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
  //   );
  //   const matchesIndex = (element) => {
  //     const jsFilter = event ? event.target.closest('.js-filter') : undefined;
  //     return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
  //   };
  //   const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
  //   const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

  //   facetsToRender.forEach((element) => {
  //     // document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
  //   });

  //   FacetFiltersForm.renderActiveFacets(parsedHTML);
  //   // FacetFiltersForm.renderAdditionalElements(parsedHTML);

  //   if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  // }

  static applyFormState(fromForm, toForm) {
    if (!fromForm || !toForm) return;

    const srcMap = new Map();
    fromForm.querySelectorAll('input, select').forEach((src) => {
      const key = (src.name || '') + '::' + (/checkbox|radio/.test(src.type) ? src.value || '' : '');
      srcMap.set(key, src);
    });

    toForm.querySelectorAll('input, select').forEach((dst) => {
      // Skip *everything* inside the custom price widget (visible + hidden);
      // our price JS owns those values to avoid unit conflicts.
      if (dst.closest('[data-price-range]')) return;

      const key = (dst.name || '') + '::' + (/checkbox|radio/.test(dst.type) ? dst.value || '' : '');
      const src = srcMap.get(key);
      if (!src) return;

      if (/checkbox|radio/.test(dst.type)) {
        dst.checked = !!src.checked;
        dst.disabled = !!src.disabled;
      } else {
        dst.value = src.value || '';
        dst.disabled = !!src.disabled;
      }
    });
  }

  static replaceFacetCounts(fromRoot, toRoot) {
    if (!fromRoot || !toRoot) return;
    fromRoot.querySelectorAll('.js-filter[data-index]').forEach((srcGroup) => {
      const idx = srcGroup.getAttribute('data-index');
      const dstGroup = toRoot.querySelector(`.js-filter[data-index="${idx}"]`);
      if (!dstGroup) return;
      const srcSel = srcGroup.querySelector('.facets__selected');
      const dstSel = dstGroup.querySelector('.facets__selected');
      if (srcSel && dstSel) dstSel.outerHTML = srcSel.outerHTML;
    });
  }

  static renderFilters(html, event) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    // Sync input state only (no innerHTML swap → no blink)
    FacetFiltersForm.applyFormState(
      parsed.getElementById('FacetFiltersForm'),
      document.getElementById('FacetFiltersForm')
    );
    FacetFiltersForm.applyFormState(
      parsed.getElementById('FacetFiltersFormMobile'),
      document.getElementById('FacetFiltersFormMobile')
    );

    // Update “X selected” counters
    FacetFiltersForm.replaceFacetCounts(
      parsed.getElementById('FacetFiltersForm'),
      document.getElementById('FacetFiltersForm')
    );
    FacetFiltersForm.replaceFacetCounts(
      parsed.getElementById('FacetFiltersFormMobile'),
      document.getElementById('FacetFiltersFormMobile')
    );

    // Refresh active pills
    // after syncing state
    ['.active-facets-mobile', '.active-facets-desktop', '#FacetFiltersPillsFormDiv'].forEach((sel) => {
      const src = parsed.querySelector(sel);
      const dst = document.querySelector(sel);
      if (src && dst) dst.innerHTML = src.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  // static updateURLHash(searchParams) {
  //   const href = `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`;
  //   const state = { searchParams };
  //   if (replace) history.replaceState(state, '', href);
  //   else history.pushState(state, '', href);
  // }
  // Supports push (default) and replace (for Clear All)
  static updateURLHash(searchParams, { replace = false } = {}) {
    const href = `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}${window.location.hash || ''}`;
    const state = { searchParams };
    try {
      if (replace) history.replaceState(state, '', href);
      else history.pushState(state, '', href);
    } catch (e) {
      // no-op (Safari private, etc.)
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  // createSearchParams(form) {
  //   const formData = new FormData(form);
  //   return new URLSearchParams(formData).toString();
  // }
  createSearchParams(form) {
    const formData = new FormData(form);
    const pairs = [];
    formData.forEach((v, k) => {
      if (v !== '' && v != null) pairs.push([k, v]);
    });
    // Sort by key, then value
    pairs.sort((a, b) => (a[0] === b[0] ? String(a[1]).localeCompare(String(b[1])) : a[0].localeCompare(b[0])));
    const usp = new URLSearchParams();
    for (const [k, v] of pairs) usp.append(k, v);
    return usp.toString();
  }

  getCurrentSort() {
    const sortSelect = document.querySelector('#SortByTop');
    if (!sortSelect) return null;

    const val = sortSelect.value;
    const def = sortSelect.dataset.default;
    // If user has chosen the default, don’t force a sort_by param
    return val && val !== def ? val : null;
  }

  onSubmitForm(searchParams, e) {
    FacetFiltersForm.renderPage(searchParams, e, true);
  }

  onSubmitHandler(e) {
    e.preventDefault();
    toggleLoading(true);

    const isSortChange = e.target.name === 'sort_by';

    const allForms = Array.from(document.querySelectorAll('facet-filters-form form'));
    if (!allForms.length) return;

    // Which form triggered this? (so its sort_by wins)
    const srcForm = e.target.closest('form');

    // 1) Get the active sort choice from the triggering form first
    let sortVal = null;
    if (srcForm) {
      const s = new FormData(srcForm).get('sort_by');
      if (s) sortVal = s;
    }
    // Fallback: first non-empty sort_by across any form
    if (!sortVal) {
      for (const f of allForms) {
        const s = new FormData(f).get('sort_by');
        if (s) {
          sortVal = s;
          break;
        }
      }
    }
    // Final fallback: check current URL for sort_by parameter
    if (!sortVal) {
      const urlParams = new URLSearchParams(window.location.search);
      sortVal = urlParams.get('sort_by');
    }

    // 2) Merge ALL params from ALL forms EXCEPT sort_by (we'll add it once at the end)
    const usp = new URLSearchParams();
    for (const f of allForms) {
      const fd = new FormData(f);
      for (const [k, v] of fd.entries()) {
        if (!v && v !== 0) continue;
        if (k === 'sort_by') continue; // <-- strip duplicates up front
        usp.append(k, v);
      }
    }

    // 3) Re-attach exactly one sort_by (preserve current sort or use new one)
    if (sortVal) usp.set('sort_by', sortVal);

    // 4) Fire the normal AJAX render + update URL (so it's shareable)
    this.onSubmitForm(usp.toString(), e);
  }

  onActiveFilterClick(e) {
    e.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      e.currentTarget.href.indexOf('?') == -1 ? '' : e.currentTarget.href.slice(e.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// ---- Clear All (capture) ----
(function () {
  if (window.__facetClearAllBound) return;
  window.__facetClearAllBound = true;

  // Match your clear links (pills bar, mobile drawer)
  const CLEAR_SEL = 'a.mobile-facets__clear, a.active-facets__clear, a[data-clear-all]';

  // Capture-phase so we run before other click handlers
  document.addEventListener(
    'click',
    function onClearAll(e) {
      const link = e.target.closest(CLEAR_SEL);
      if (!link) return;

      // Stop everything else from handling this click
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      // 1) Reset both facet forms (desktop + mobile)
      document.querySelectorAll('facet-filters-form form').forEach((f) => f.reset());

      // 2) Clear custom price hidden fields (so price filter is removed)
      document.querySelectorAll('[data-price-range] .pr-hidden').forEach((el) => {
        el.value = '';
      });

      // 3) Clear URL query in-place (no new history entry)
      const newHref = window.location.pathname + (window.location.hash || '');
      history.replaceState({ searchParams: '' }, '', newHref);

      // 4) AJAX refresh WITHOUT URL updates (keeps it clean)
      FacetFiltersForm.renderPage('', null, false);
    },
    true
  );
})();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

//customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink?.setAttribute('role', 'button');
    facetLink?.addEventListener('click', this.closeFilter.bind(this));
    facetLink?.addEventListener('keyup', (e) => {
      e.preventDefault();
      if (e.code.toUpperCase() === 'SPACE') this.closeFilter(e);
    });
    toggleLoading(false);
  }

  closeFilter(e) {
    e.preventDefault();
    toggleLoading(true);
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(e);
  }
}

customElements.define('facet-remove', FacetRemove);

// Custom show / hide spinner loading icon
function toggleLoading(isLoading) {
  const spinner = document.querySelector('.loading-svg');
  spinner.classList.toggle('visible', isLoading);
}
